import React from 'react';
import ClassAssembly5B from 'views/ClassAssembly5B';

const ClassAssembly5BPage = () => {
    return <ClassAssembly5B />;
  };
  
  export default ClassAssembly5BPage;
  //5B